import {useId} from 'react';

import InfoButton from '@/components/InfoButton/InfoButton';
import ScoreBar from '@/components/ScoreBar/ScoreBar';
import TipsToConsider from '@/components/TipsToConsider/TipsToConsider';
import {Text} from '@/components/Typography';
import LIVE_TOUR_TARGETS from '@/consts/liveTourTargets';
import useCalibration from '@/hooks/experienceScore/useCalibration';
import useScoreData from '@/hooks/experienceScore/useScoreData';
import useTipsToConsider from '@/hooks/experienceScore/useTipsToConsider';
import {getContent} from '@/services/content/content';
import modalService from '@/services/modal/modalService';

const ScoreSection = () => {
    const {firstUsageTime, lastUsageTime} = useCalibration();
    const {scorePercentage, status} = useScoreData();
    const tipsToConsider = useTipsToConsider();
    const {title, explanation} = getContent().experienceScoreContent ?? {};
    const titleId = useId();

    const onInfoClick = () => modalService.openInfo();

    return (
        <>
            <div className='flex w-full flex-col gap-4' data-live-tour-target={LIVE_TOUR_TARGETS.EXPERIENCE_SCORE}>
                <div className='w-full text-left'>
                    <div className='flex items-center justify-between gap-2'>
                        <Text id={titleId} as='h1' variant='pageTitle'>
                            {title}
                        </Text>
                        {explanation && <InfoButton label={explanation.title} onClick={onInfoClick} />}
                    </div>
                    {firstUsageTime && lastUsageTime && (
                        <Text as='p' variant='subsectionTitle' className='mt-1 text-orion-divider dark:text-romance-85'>
                            {firstUsageTime} - {lastUsageTime}
                        </Text>
                    )}
                </div>
                <ScoreBar value={scorePercentage} status={status} labelledBy={titleId} />
            </div>
            <TipsToConsider
                tipsToConsiderData={tipsToConsider}
                containerClassName='mt-8'
                liveTourTarget={LIVE_TOUR_TARGETS.TIPS_TO_CONSIDER}
            />
        </>
    );
};

export default ScoreSection;
